var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"payments-batch","route":"/reports/billing-payments-batch","file-name":"pagamentos-por-lote.xlsx","period-label":"Período do pagamento","columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }